import { useRef, useState } from 'react'
import classes from './MultipleCheckboxCell.module.css'

const MultipleCheckboxCell = ({direction, action, identifier, isDisabled, items, defaultValues}) => {

    const checkboxRef = useRef(null)

    function fillArr() {
        let arr = new Array(items.length);
        for (let i = 0; i < arr.length; i++) {
            arr[i] = {
                id: items[i].id,
                checked: false
            }
        }


        if (defaultValues && defaultValues.length > 0) {
            defaultValues.forEach(element => {
                arr.forEach(item => {
                    if (item.id == element) {
                        item.checked = true
                    }
                })
            });
        }
        return arr
    }

    const [checkedStateV2, setCheckedStateV2] = useState(fillArr());


    const handleOnChange = (position, item, event) => {
        const updatedCheckedStatev2 = checkedStateV2.map((el, index) =>
            el.id == item.id ? {...el, checked: event.target.checked} : el
        );

        setCheckedStateV2(updatedCheckedStatev2)       

        let arr = []

        items.forEach(item => {
            updatedCheckedStatev2.forEach(elem => {
                if (elem.checked) {
                    if (item.id == elem.id) {
                        arr.push(item)
                    }
                }
            })
        })
        if (action) {
            action({
                idArr: (arr && arr.length > 0) ? arr : null
            })
        }
    };

    return <div className={`${classes.checkbox_field} ${isDisabled ? classes.disabled_cursor : ''} ${direction ? classes[direction] : ''} `}>
        {items && items.map((item, index) => (
            <div key={index} className={classes.checkbox_field_item}>            
                <input ref={checkboxRef} type="checkbox" id={`custom-checkbox-${index}`} name={`${item.first_name}_${item.last_name}`} checked={checkedStateV2[index].checked} className={`${classes.checkbox}`} onChange={(event) => handleOnChange(index, item, event)} />
                <label htmlFor={`custom-checkbox-${index}`} className={classes.label}>
                    <div>{item.first_name} {item.last_name} {item.id}</div>
                    <div className={classes.person_number}>NG{item.person_number}</div>
                </label>
            </div> 
        ))}
        
    </div>
}

export default MultipleCheckboxCell